import {
  GET_PROJECT_ALL_BRANDS_RESPONSE,
  GET_PROJECT_DAILY_STATS,
  GET_PROJECT_SOV_TIME_SERIES,
  GET_PROJECT_VISIBILITY_CHART,
} from '../../query/project/stats/keys';
import { GET_KEYWORDS_DAILY_STATS_FOR_PROJECT } from '../../query/keyword/stats/keys';
import { QueryClient } from '@tanstack/react-query';
import { GET_COMMON_KEYWORDS } from '../../query/keyword/keys';
import { GET_SOURCES_FOR_PROJECT } from '../../query/monitor/data/sources/keys';
import { GET_PROJECT_MONITORS } from '../../query/monitor/keys';

export const invalidateProjectQueries = (queryClient: QueryClient, projectId: number): void => {
  console.log(`[QueryInvalidation] Invalidating queries for project ${projectId}`);

  const queries = [
    GET_PROJECT_DAILY_STATS,
    GET_KEYWORDS_DAILY_STATS_FOR_PROJECT,
    GET_COMMON_KEYWORDS,
    GET_SOURCES_FOR_PROJECT,
    GET_PROJECT_ALL_BRANDS_RESPONSE,
    GET_PROJECT_VISIBILITY_CHART,
    GET_PROJECT_SOV_TIME_SERIES,
  ];

  queries.forEach((queryKey) => {
    queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] === queryKey,
      refetchType: 'active',
    });
  });

  queryClient.invalidateQueries({
    queryKey: [GET_PROJECT_MONITORS, projectId],
    refetchType: 'active',
  });
};
